import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Button, Card, Col, Form, Input, Row, Select } from 'antd';

import {
  branchAccessEndpoints,
  branchApiEndpoints,
  companyAccessEndpoints,
  customerApiEndpoints,
} from '@/api/endpoints';

import {
  rules,
  validateConfirmPassword,
  validateEmail,
  // validateEmail,
  // validateMobileNumber,
  validatePassword,
} from '@/utils/validation/FormValidation';

import { handlePostApi } from '@/api/crud';
import { useGetApiList } from '@/apiError/apiShow';
import { useFetch } from '@/hooks';
import { optionSearchFunction } from '@/utils/common';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import LoadingOverlay from '@/utils/loading/loadingOverlay';

const CreateCustomer = () => {
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();
  const navigate = useNavigate();

  const navigateToList = () => navigate('/user/list/');
  const { data } = useFetch(branchAccessEndpoints.retrieveList);

  const { data: { data: storeList } = {}, isPending: storeLoading } =
    useGetApiList('/admin/stores/');

  return (
    <>
      <section className="">
        <Card>
          <Form
            className="username"
            form={form}
            onFinish={(value) => {
              handlePostApi(
                customerApiEndpoints.create,
                value,
                setLoading,
                form,
                navigateToList,
              );
            }}
            layout="vertical"
          >
            <LoadingOverlay loading={loading} />
            <GlobalDivider name="Create User" />

            <Row gutter={24}>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Username"
                  name="username"
                  rules={rules.required}
                  hasFeedback
                  validateTrigger="onChange"
                >
                  <Input placeholder="Username" />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="First Name"
                  name="firstName"
                  hasFeedback
                  rules={rules.required}
                  validateTrigger="onChange"
                >
                  <Input placeholder="First Name" />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Last Name"
                  name="lastName"
                  hasFeedback
                  rules={rules.required}
                  validateTrigger="onChange"
                >
                  <Input placeholder="Last Name" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  hasFeedback
                  label="Email"
                  name="email"
                  // rules={[
                  //   {
                  //     validator: (_, value) => validateEmail(value),
                  //   },
                  // ]}

                  rules={[
                    {
                      type: 'email',
                      message: 'Please enter a valid e-mail',
                    },
                  ]}
                >
                  <Input placeholder="example@domin.com" autoComplete="off" />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  hasFeedback
                  label="Address"
                  name="address"
                  rules={[
                    {
                      required: false,
                      message: 'Address Required',
                    },
                  ]}
                >
                  <Input placeholder="Address" autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Mobile"
                  name="mobileNumber"
                  rules={rules.phoneNumberNew}
                  // validateTrigger="onChange"
                  // hasFeedback
                >
                  <Input
                    // type="number"
                    showCount
                    placeholder="98XXXXXXX"
                    maxLength={10}
                    max={10}
                    onKeyDown={(e) => {
                      if (
                        (e.key < '0' || e.key > '9') &&
                        e.key !== 'Backspace' &&
                        e.key !== 'Delete' &&
                        e.key !== 'ArrowLeft' &&
                        e.key !== 'ArrowRight'
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Select Company"
                  name="branchIds"
                  validateTrigger="onChange"
                  rules={[
                    {
                      required: true,
                      message: 'please select a company',
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select Company"
                    filterOption={optionSearchFunction}
                    options={data?.map((item) => {
                      return {
                        value: item?.referenceId,
                        label: item?.name,
                      };
                    })}
                    mode="multiple"
                  />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Store"
                  name="storeId"
                  validateTrigger="onChange"
                  required
                >
                  <Select
                    showSearch
                    allowClear
                    mode="multiple"
                    loading={storeLoading}
                    placeholder="Select Store"
                    filterOption={optionSearchFunction}
                    options={storeList?.map((item) => {
                      return {
                        value: item.referenceId,
                        label: item?.name,
                      };
                    })}
                  />
                </Form.Item>
              </Col>

              {/* <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      validator: (_, value) => validatePassword(value),
                    },
                  ]}
                  validateTrigger="onChange"
                  hasFeedback
                >
                  <Input.Password type="password" placeholder="Password" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item
                  label="Confirm Password"
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password!',
                    },
                    ({ getFieldValue }) => ({
                      validator: (_, value) =>
                        validateConfirmPassword(getFieldValue)(_, value),
                    }),
                  ]}
                  hasFeedback
                >
                  <Input.Password
                    type="password"
                    placeholder="Confirm Password"
                  />
                </Form.Item>
              </Col>*/}
            </Row>

            <div className="flex justify-end">
              <div className="flex gap-2">
                <Button type="primary" htmlType="submit">
                  Create
                </Button>
                <Button
                  className="auto-danger-btn"
                  onClick={() => navigate(-1)}
                >
                  Back
                </Button>
              </div>
            </div>
          </Form>
        </Card>
      </section>
    </>
  );
};

export default CreateCustomer;
